import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import React, { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import "../TGases.css";
import { plotBackground } from "../../../config/colors";


export default function PerfilGasesSalidaCiclones() {
  const [flujosSolidosSC, setFlujosSolidosSC] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [caudalGasSC, setCaudalGasSC] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeN2SC, setPorcentajeN2SC] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentaje02SC, setPorcentaje02SC] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeH20SC, setPorcentajeH20SC] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeS2SC, setPorcentajeS2SC] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeS02SC, setPorcentajeS02SC] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeAs2S3SC, setPorcentajeAs2S3SC] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeAs4O6SC, setPorcentajeAs4O6SC] = useState({
    value: [],
    fecha: [],
    estado: [],
  });


  // Fecha inicial y final
  const [date, setDate] = useState({ start: "19-01-2023", end: "25-01-2023" });

  // Objeto inicial de la peticion
  const initialFetch = {
    idSeccion: 3,
    secuencia: 38,
    ultimo: 0,
    frecuencia: 5,
    dias: 7,
  };

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
    const { data } = await getValoresPeriodo(initialFetch);

    populateFlujosSolidosSC(data);
    populateCaudalGasSC(data);
    populatePorcentajen2SC(data);
    populatePorcentaje02SC(data);
    populatePorcentajeH20SC(data);
    populatePorcentajeS2SC(data);
    populatePorcentajeS02SC(data);
    populatePorcentajeAs2S3SC(data);
    populatePorcentajeAs4O6SC(data);
      //#endregion
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateFlujosSolidosSC(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Flujo de Sólidos Salida Ciclones"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setFlujosSolidosSC({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCaudalGasSC(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Caudal de Gas Salida Ciclones"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setCaudalGasSC({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajen2SC(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%N2 Salida Ciclones"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeN2SC({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentaje02SC(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%O2 Salida Ciclones"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentaje02SC({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajeH20SC(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%H2O Salida Ciclones"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeH20SC({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajeS2SC(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%S2 Salida Ciclones"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeS2SC({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajeS02SC(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%SO2 Salida Ciclones"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeS02SC({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajeAs2S3SC(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%As2S3 Salida Ciclones"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeAs2S3SC({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajeAs4O6SC(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%As4O6 Salida Ciclones"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeAs4O6SC({
      fecha: arrFechas,
      value: arrValues,
    });
  }

 
  return (
    <>
       <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil de Gases Salida Ciclones"}
            subtitle={"Periodo " + date.start + " - " + date.end}
          >
            {/** -------------------------------- Flujo de Sólidos Salida Ciclones --------------------------------------- */}
            <Chart.Line
              name="Flujo de Sólidos Salida Ciclones"
              data={flujosSolidosSC.value}
              yAxis={0}
            />
            {/** -------------------------------- Caudal de Gas Salida Ciclones --------------------------------------- */}
            <Chart.Line
              name="Caudal de Gas Salida Ciclones"
              data={caudalGasSC.value}
              yAxis={0}
            />
            {/** -------------------------------- %N2 Salida Ciclones --------------------------------------- */}
            <Chart.Line
              name="%N2 Salida Ciclones"
              data={porcentajeN2SC.value}
              yAxis={1}
            />
            {/** -------------------------------- %O2 Salida Ciclones --------------------------------------- */}
            <Chart.Line
              name="%O2 Salida Ciclones"
              data={porcentaje02SC.value}
              yAxis={1}
            />
            {/** -------------------------------- %H2O Salida Ciclones --------------------------------------- */}
            <Chart.Line
              name="%H2O Salida Ciclones"
              data={porcentajeH20SC.value}
              yAxis={1}
            />
            {/** -------------------------------- %S2 Salida Ciclones --------------------------------------- */}
            <Chart.Line
              name="%S2 Salida Ciclones"
              data={porcentajeS2SC.value}
              yAxis={1}
            />
            {/** -------------------------------- %SO2 Salida Ciclones --------------------------------------- */}
            <Chart.Line
              name="%SO2 Salida Ciclones"
              data={porcentajeS02SC.value}
              yAxis={1}
            />
            {/** -------------------------------- %As2S3 Salida Ciclones --------------------------------------- */}
            <Chart.Line
              name="%As2S3 Salida Ciclones"
              data={porcentajeAs2S3SC.value}
              yAxis={1}
            />
            {/** -------------------------------- %As4O6 Salida Ciclones --------------------------------------- */}
            <Chart.Line
              name="%As4O6 Salida Ciclones"
              data={porcentajeAs4O6SC.value}
              yAxis={1}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={flujosSolidosSC.fecha} />

            <Chart.YAxis
              labelSuffix=" Nm3/h"
              title="Caudal de Gases, Nm3/h"
              lineWidth={2}
              lineColor="white"
              min={0}
              max={80000}
            />

            <Chart.YAxis
              labelSuffix=" %"
              title="Contenido, %"
              lineWidth={2}
              opposite={true}
              lineColor="white"
              min={0}
              max={80}
            />

            <Chart.Tooltip valueSuffix="" />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
